import React from 'react';
import usePushNotification from '../hooks/usePushNotification';

/**
 * Sidebar-Toggle für Push-Benachrichtigungen.
 * Im PWA-Mode (iOS Add-to-Home) auch dort verfügbar.
 */
export default function PushToggle({ api }) {
  const { state, supported, isSubscribed, subscribe, unsubscribe, test } = usePushNotification(api);

  if (!supported) return null;

  return (
    <div className="push-toggle">
      <div className="push-toggle-label">
        <span className="push-toggle-icon">{isSubscribed ? '🔔' : '🔕'}</span>
        <span className="push-toggle-text">
          Push-Benachrichtigungen
          {state === 'subscribing' && ' (aktiviere…)'}
          {state === 'denied'      && ' (Browser blockt)'}
          {state === 'error'       && ' (Fehler)'}
        </span>
      </div>
      <div className="push-toggle-actions">
        {!isSubscribed ? (
          <button className="btn-ghost-sm" onClick={subscribe} disabled={state === 'subscribing'} title="Push-Benachrichtigungen für dieses Gerät aktivieren">
            Aktivieren
          </button>
        ) : (
          <>
            <button className="btn-ghost-sm" onClick={test} title="Test-Push">Test</button>
            <button className="btn-ghost-sm" onClick={unsubscribe} title="Deaktivieren">Aus</button>
          </>
        )}
      </div>
    </div>
  );
}
